import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SectionCard } from '@themes/aegix';

export interface ProfileRolesSectionProps {
  /** Role / group display names; sorted alphabetically for display. */
  roles?: string[];
  title?: string;
  e2eTitle?: string;
}

/**
 * Read-only list of the user's roles / group memberships. Lifted as-is from
 * both apps (it was already prop-only and app-neutral).
 */
export function ProfileRolesSection({
  roles,
  title,
  e2eTitle,
}: ProfileRolesSectionProps) {
  const { t } = useTranslation();
  const sortedRoles = [...(roles ?? [])].sort((a, b) => {
    if (!b) return -1;
    if (!a) return 1;
    return a.localeCompare(b);
  });

  return (
    <SectionCard title={title ?? t('roles.title', 'Roles')} e2eTitle={e2eTitle}>
      {sortedRoles.map((item, index) => (
        <Flex
          key={`${item}-${index}`}
          textAlign="start"
          alignItems="center"
          justifyContent="space-between"
          p={1.25}
        >
          <Text color="text.primary">{item}</Text>
        </Flex>
      ))}
    </SectionCard>
  );
}

export default ProfileRolesSection;
